export class InvoiceSetting {
    CalculateTaxOnSale: boolean;
    CalculateDiscountOnSale: boolean;    
    CalculateTaxAfterDiscount: boolean;
    DisplayDiscountOnSale: boolean;
    DisplayTaxComponentOnSale: boolean;
    DisplayTaxOnSale: boolean;   
    EnableDiscountEditOnSale: boolean;     
    AllowInvoiceDiscount: boolean;
    ShowInvoiceNumberPostCreation: boolean;
    StoreId: number;
    SelectedInvoiceTemplateId: number;
    
}